<template>
  <div class="luttica-message" v-show="showBox">
    <CloudModal
      :value="showBox"
      width="500"
      @on-cancel="cancel"
      :title="title"
      class-name="confirm-logout"
    >
      <div class="content">
        <LutticaIcon type="iconwarning-circle" size="30"></LutticaIcon>
        <span>{{ content }}</span>
      </div>
      <div slot="footer">
        <CloudButton
          class="cancel-button"
          shape="circle"
          style="margin-right: 10px"
          @click="cancel"
        >
          取消
        </CloudButton>
        <CloudButton shape="circle" type="primary" @click="confirm">确定</CloudButton>
      </div>
    </CloudModal>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    title: String,
    content: String,
    isShowCancelBtn: {
      type: Boolean,
      default: false,
    },
    isShowConfirmBtn: {
      type: Boolean,
      default: false,
    },
    cancelBtnText: {
      type: [String, Boolean],
      default: false,
    },
    confirmBtnText: {
      type: [String, Boolean],
      default: false,
    },
    onOk: Function,
    onCancel: Function,
  },
  data() {
    return {
      showBox: false,
      form: {},
      resolve: '',
      reject: '',
      promise: '', // 保存promise对象
    };
  },
  methods: {
    async confirm() {
      if (this.onOk) {
        this.onOk();
      }
      this.showBox = false;
      this.reject('confirm');
      this.remove();
    },
    cancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.showBox = false;
      this.reject('cancel');
      this.remove();
    },
    showLutticaMessage() {
      this.showBox = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
    remove() {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy() {
      this.$destroy();
      document.body.removeChild(this.$el);
    },
  },
};
</script>

<style lang="less">
.luttica-message {
  .confirm-logout {
    .ivu-modal-header {
      span {
        font-size: 20px;
        float: left !important;
        .ivu-icon {
          font-size: 20px;
          color: @primary-color;
        }
      }
    }
    .ivu-modal {
      .ivu-modal-content {
        width: unset;
      }
    }
    .ivu-modal-footer {
      .cancel-button {
        border-color: @primary-color;
        &:hover {
          background-color: #e2f0ff;
        }
      }
    }
    .content {
      text-align: center;
      line-height: 2;
      font-size: 14px;
      .ivu-icon {
        margin-right: 10px;
        color: @warning-color;
      }
    }
  }
}
</style>
